import React from 'react'
import cn from 'classnames'
import { paymentIcons, resolvePaymentIcon } from '../../../utils/icons'

import styles from './PaymentsList.module.scss'

const Payment = ({ id, selected, disabled, cardType, label, onSelect, className }) => {
  const classNames = cn(styles.payment, { [styles.selected]: selected, [styles.disabled]: disabled }, className)
  const icon = React.cloneElement(resolvePaymentIcon(cardType)?.open ?? paymentIcons['Unknown Card']?.open, { className: styles.icon })

  return (
    <li className={classNames} onClick={onSelect}>
      {icon}
      <span>{label}</span>
    </li>
  )
}

const PaymentsList = ({ payments, selectedPaymentId, disabled, onSelect, className }) => {
  const classNames = cn(styles.paymentsList, className)

  return (
    <ul className={classNames}>
      {payments?.map?.((payment, index) => {
        const isSelected = payment.id === selectedPaymentId

        const handleOnSelect = () => {
          if (disabled) return
          onSelect(payment?.id, index)
        }

        return (
          <Payment
            key={payment?.id ?? index}
            label={payment.label}
            cardType={payment.cardType}
            selected={isSelected}
            disabled={disabled}
            onSelect={handleOnSelect}
          />
        )
      })}
    </ul>
  )
}

export default PaymentsList
